import { useEffect, useState } from 'react';
import AppHeader from '../../components/AppHeader';
import { catalogApi } from '../../api';

const ATTR_TYPES = [
  { v: 'text', l: 'Text' }, { v: 'number', l: 'Číslo' }, { v: 'select', l: 'Výběr' },
  { v: 'boolean', l: 'Ano/Ne' }, { v: 'date', l: 'Datum' },
];

export default function CatalogManager() {
  const [tree, setTree] = useState([]);
  const [openCat, setOpenCat] = useState(null);
  const [openSub, setOpenSub] = useState(null);
  const [newCat, setNewCat] = useState('');
  const [newSub, setNewSub] = useState('');
  const [typeForm, setTypeForm] = useState(null); // { subId, id?, name, unit, attribute_schema }

  const load = () => catalogApi.tree().then((r) => setTree(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const addCategory = async () => { if (!newCat.trim()) return; await catalogApi.createCategory({ name: newCat.trim() }); setNewCat(''); load(); };
  const delCategory = async (id) => { if (confirm('Smazat kategorii včetně podkategorií a typů?')) { await catalogApi.deleteCategory(id); load(); } };
  const addSub = async (catId) => { if (!newSub.trim()) return; await catalogApi.createSubcategory({ category_id: catId, name: newSub.trim() }); setNewSub(''); load(); };
  const delSub = async (id) => { if (confirm('Smazat podkategorii včetně typů?')) { await catalogApi.deleteSubcategory(id); load(); } };
  const delType = async (id) => { if (confirm('Smazat typ položky?')) { await catalogApi.deleteItemType(id); load(); } };

  const openTypeForm = (subId, t) => setTypeForm(t
    ? { subId, id: t.id, name: t.name, unit: t.unit, attribute_schema: t.attribute_schema || [] }
    : { subId, name: '', unit: 'ks', attribute_schema: [] });

  const saveType = async () => {
    // Atributy typu „výběr": surový text možností (optionsText) převedeme na pole až teď.
    const attribute_schema = typeForm.attribute_schema.map((a) => {
      const { optionsText, options, ...rest } = a;
      if (a.type === 'select') {
        const raw = optionsText !== undefined ? optionsText : (options || []).join(', ');
        return { ...rest, options: raw.split(',').map((s) => s.trim()).filter(Boolean) };
      }
      return rest; // u ostatních typů options nepotřebujeme
    });
    const payload = { subcategory_id: typeForm.subId, name: typeForm.name, unit: typeForm.unit, attribute_schema };
    if (typeForm.id) await catalogApi.updateItemType(typeForm.id, payload);
    else await catalogApi.createItemType(payload);
    setTypeForm(null); load();
  };

  const setAttr = (i, patch) => setTypeForm((f) => ({ ...f, attribute_schema: f.attribute_schema.map((a, idx) => idx === i ? { ...a, ...patch } : a) }));
  const addAttr = () => setTypeForm((f) => ({ ...f, attribute_schema: [...f.attribute_schema, { key: '', label: '', type: 'text', required: false }] }));
  const delAttr = (i) => setTypeForm((f) => ({ ...f, attribute_schema: f.attribute_schema.filter((_, idx) => idx !== i) }));

  return (
    <div>
      <AppHeader subtitle="Katalog materiálu" />
      <div className="container-wide" style={{ paddingTop: 24 }}>

        <div className="card mb-16">
          <div className="flex gap-8">
            <input className="form-input flex-1" placeholder="Nová kategorie" value={newCat} onChange={(e) => setNewCat(e.target.value)} />
            <button className="btn btn-primary" onClick={addCategory}>+ Kategorie</button>
          </div>
        </div>

        {tree.map((cat) => (
          <div key={cat.id} className="card mb-16">
            <div className="flex" style={{ justifyContent: 'space-between', alignItems: 'center' }}>
              <h3 style={{ cursor: 'pointer' }} onClick={() => setOpenCat(openCat === cat.id ? null : cat.id)}>
                {openCat === cat.id ? '▾' : '▸'} {cat.name} <span className="text-muted" style={{ fontSize: '0.8rem' }}>({cat.subcategories.length})</span>
              </h3>
              <button className="btn btn-danger btn-sm" onClick={() => delCategory(cat.id)}>Smazat</button>
            </div>

            {openCat === cat.id && (
              <div style={{ marginTop: 12, paddingLeft: 12, borderLeft: '2px solid var(--border)' }}>
                <div className="flex gap-8 mb-16">
                  <input className="form-input flex-1" placeholder="Nová podkategorie" value={newSub} onChange={(e) => setNewSub(e.target.value)} />
                  <button className="btn btn-outline btn-sm" onClick={() => addSub(cat.id)}>+ Podkategorie</button>
                </div>

                {cat.subcategories.map((sub) => (
                  <div key={sub.id} style={{ marginBottom: 10 }}>
                    <div className="flex" style={{ justifyContent: 'space-between', alignItems: 'center' }}>
                      <strong style={{ cursor: 'pointer' }} onClick={() => setOpenSub(openSub === sub.id ? null : sub.id)}>
                        {openSub === sub.id ? '▾' : '▸'} {sub.name} <span className="text-muted" style={{ fontSize: '0.8rem' }}>({sub.item_types.length})</span>
                      </strong>
                      <span>
                        <button className="btn btn-outline btn-sm" onClick={() => openTypeForm(sub.id)}>+ Typ</button>{' '}
                        <button className="btn btn-danger btn-sm" onClick={() => delSub(sub.id)}>×</button>
                      </span>
                    </div>
                    {openSub === sub.id && (
                      <ul style={{ listStyle: 'none', padding: '6px 0 0 16px' }}>
                        {sub.item_types.map((t) => (
                          <li key={t.id} className="flex" style={{ justifyContent: 'space-between', padding: '3px 0' }}>
                            <span>{t.name} <span className="text-muted">({t.unit})</span>
                              {t.attribute_schema?.length > 0 && <span className="badge badge-in" style={{ marginLeft: 6 }}>{t.attribute_schema.length} param.</span>}
                            </span>
                            <span>
                              <button className="btn btn-outline btn-sm" onClick={() => openTypeForm(sub.id, t)}>Upravit</button>{' '}
                              <button className="btn btn-danger btn-sm" onClick={() => delType(t.id)}>×</button>
                            </span>
                          </li>
                        ))}
                        {sub.item_types.length === 0 && <li className="text-muted" style={{ fontSize: '0.85rem' }}>Žádné typy.</li>}
                      </ul>
                    )}
                  </div>
                ))}
                {cat.subcategories.length === 0 && <p className="text-muted" style={{ fontSize: '0.85rem' }}>Žádné podkategorie.</p>}
              </div>
            )}
          </div>
        ))}

        {/* Modal pro typ položky */}
        {typeForm && (
          <div style={modalBackdrop} onClick={() => setTypeForm(null)}>
            <div className="card" style={{ maxWidth: 560, width: '100%', maxHeight: '85vh', overflow: 'auto' }} onClick={(e) => e.stopPropagation()}>
              <h3 className="mb-16">{typeForm.id ? 'Upravit typ položky' : 'Nový typ položky'}</h3>
              <div className="flex gap-8">
                <div className="form-group flex-1">
                  <label>Název</label>
                  <input className="form-input" value={typeForm.name} onChange={(e) => setTypeForm({ ...typeForm, name: e.target.value })} />
                </div>
                <div className="form-group" style={{ width: 110 }}>
                  <label>Jednotka</label>
                  <input className="form-input" value={typeForm.unit} onChange={(e) => setTypeForm({ ...typeForm, unit: e.target.value })} />
                </div>
              </div>

              <div className="flex" style={{ justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                <strong>Parametry (atributy)</strong>
                <button className="btn btn-outline btn-sm" onClick={addAttr}>+ Atribut</button>
              </div>
              {typeForm.attribute_schema.map((a, i) => (
                <div key={i} className="card" style={{ padding: 10, marginBottom: 8 }}>
                  <div className="flex gap-8">
                    <input className="form-input flex-1" placeholder="klíč (např. litry)" value={a.key} onChange={(e) => setAttr(i, { key: e.target.value })} />
                    <input className="form-input flex-1" placeholder="popisek" value={a.label} onChange={(e) => setAttr(i, { label: e.target.value })} />
                  </div>
                  <div className="flex gap-8" style={{ marginTop: 6, alignItems: 'center' }}>
                    <select className="form-input" style={{ flex: 1 }} value={a.type} onChange={(e) => setAttr(i, { type: e.target.value })}>
                      {ATTR_TYPES.map((t) => <option key={t.v} value={t.v}>{t.l}</option>)}
                    </select>
                    <input className="form-input" style={{ width: 90 }} placeholder="jedn." value={a.unit || ''} onChange={(e) => setAttr(i, { unit: e.target.value })} />
                    <label style={{ fontSize: '0.8rem', whiteSpace: 'nowrap' }}>
                      <input type="checkbox" checked={!!a.required} onChange={(e) => setAttr(i, { required: e.target.checked })} /> povinné
                    </label>
                    <button className="btn btn-danger btn-sm" onClick={() => delAttr(i)}>×</button>
                  </div>
                  {a.type === 'select' && (
                    <input className="form-input" style={{ marginTop: 6 }} placeholder="možnosti oddělené čárkou (např. 3x3, 6x3)"
                      value={a.optionsText !== undefined ? a.optionsText : (a.options || []).join(', ')}
                      onChange={(e) => setAttr(i, { optionsText: e.target.value })} />
                  )}
                </div>
              ))}

              <div className="flex gap-8 mt-16">
                <button className="btn btn-primary flex-1" onClick={saveType} disabled={!typeForm.name.trim()}>Uložit</button>
                <button className="btn btn-outline" onClick={() => setTypeForm(null)}>Zrušit</button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

const modalBackdrop = {
  position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1000,
  display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16,
};
